import React, { useState } from 'react';

import dayjs, { Dayjs } from 'dayjs';

import { KbaQuestion } from 'api/KbaApi';
import { Button } from 'components/Buttons/Button';
import ButtonOption from 'components/Buttons/ButtonOption';
import { ButtonType } from 'enums/ButtonType';

import StepsProgress from './StepsProgress';
import styles from './SurveyStep.module.scss';
import Timer from './Timer';

interface KbaSurveyProps {
  questions: KbaQuestion[];
  onConfirm: (answers: string[]) => void;
  dueDate: Dayjs;
  onExpire: (answers: string[]) => void;
}

const SurveyStep = ({ questions, onConfirm, onExpire, dueDate }: KbaSurveyProps) => {
  const [step, setStep] = useState(0);
  const [stopTimer, setStopTimer] = useState(false);
  const [answers, setAnswers] = useState<string[]>([]);

  const currentQuestion = questions[step];
  const isFinalStep = questions.length === step + 1;

  const onNextStep = () => {
    setStep(step + 1);
  };
  const onConfirmAnswers = () => {
    setStopTimer(true);
    onConfirm(answers);
  };

  const onExpireAnswers = () => {
    onExpire(answers);
  };

  const onSelectAnswer = (answer: string) => {
    answers[step] = answer;
    setAnswers([...answers]);
  };

  const button = isFinalStep ? (
    <Button
      className={styles.nextButton}
      buttonType={ButtonType.Primary}
      onClick={onConfirmAnswers}
      disabled={!answers[step]}
    >
      Confirm
    </Button>
  ) : (
    <Button className={styles.nextButton} onClick={onNextStep} disabled={!answers[step]} withArrow>
      Continue
    </Button>
  );

  const expirySeconds = dueDate.diff(dayjs(), 'second');

  return (
    <>
      <StepsProgress step={step} questions={questions} />
      <div className={styles.kbaWrapper}>
        <div className={styles.kbaHeader}>
          <p className={styles.text}>
            Question {step + 1} of {questions.length}
          </p>
          <Timer onExpire={onExpireAnswers} stopTimer={stopTimer} expirySeconds={expirySeconds} />
        </div>
        <div className={styles.kbaQuestionWrapper}>
          <p className={styles.kbaQuestionTitle}>{currentQuestion.text}</p>
          <div className={styles.kbaQuestionWrapper}>
            {currentQuestion.answers.map((answer) => {
              return (
                <ButtonOption
                  className={styles.buttonOption}
                  key={answer}
                  active={answers[step] === answer}
                  onClick={() => onSelectAnswer(answer)}
                >
                  {answer}
                </ButtonOption>
              );
            })}
          </div>
        </div>
        <div className={styles.kbaFooter}>{button}</div>
      </div>
    </>
  );
};

export default SurveyStep;
